import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { ProductScanComponent } from './pages/product-scan/product-scan.component';
import { LandingComponent } from './pages/landing/landing.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CameraScannerComponent } from './components/camera-scanner/camera-scanner.component';
import { CameraDemoComponent } from './pages/camera-demo/camera-demo.component';
import { FingerprintErrorComponent } from './pages/fingerprint-error/fingerprint-error.component';
import { MobileGuard } from '../services/mobile.guard';
import { MobileOnlyComponent } from './components/mobile-only/mobile-only.component';
import { DownloadComponent } from './pages/download/download.component';

import { PrivacyPageComponent } from './pages/regulatory/privacy.page';
import { TermsPageComponent } from './pages/regulatory/terms.page';

export function gs1Matcher(segments: UrlSegment[]): UrlMatchResult | null {
    if (segments.length >= 2 && segments[0].path === '01') {
        return {
            consumed: segments
        };
    }
    return null;
}

export const routes: Routes = [
    {
        path: 'privacy',
        component: PrivacyPageComponent
    },
    {
        path: 'terms',
        component: TermsPageComponent
    },
    {
        path: 'scanner',
        component: CameraScannerComponent,
        canActivate: [MobileGuard]
    },
    {
        path: 'mobile-only',
        component: MobileOnlyComponent
    },
    {
        path: 'qrcode-error',
        component: FingerprintErrorComponent
    },
    {
        path: 'demo',
        component: CameraDemoComponent
    },
    {
        path: 'd',
        component: DownloadComponent,
    },
    {
        path: 'product/:gtin/details/:qrCode',
        component: ProductScanComponent
    },
    {
        path: 's/:qrCode',
        component: ProductScanComponent
    },
    {
        matcher: gs1Matcher,
        component: ProductScanComponent
    },
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: ':qrCode',
        component: ProductScanComponent
    },
    {
        path: '**',
        component: LandingComponent
    }
];
